import { useState, useLayoutEffect, useEffect, type RefObject } from "react";

const useWidth = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  ratio: number = 1,
): number | null => {
  const [width, setWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    const domElement = ref?.current;
    if (!domElement) {
      setWidth(null);
      return;
    }

    setWidth(domElement.offsetWidth * ratio);
  }, [ref, ratio]);

  useEffect(() => {
    const domElement = ref?.current;
    if (!domElement) {
      return;
    }

    let animationFrame: number;
    const onResize = () => {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = window.requestAnimationFrame(() => {
        if (domElement) {
          setWidth(domElement.offsetWidth * ratio);
        }
      });
    };

    window.addEventListener("resize", onResize);
    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", onResize);
    };
  }, [ref, ratio]);

  return width;
};

export default useWidth;
